import React from "react";

const Profile = () => {
  return (
    <img
      src={require(`../../images/profile_tmp.png`)}
      width="130px"
      height="100px"
      alt=""
    />
  );
};

export default Profile;
